import { Injectable } from '@angular/core';
import {ConfirmationService} from "primeng/primeng";
import {NotificationsService} from "@catcore/services/notifications.service";

@Injectable()
export class UpdateService {

  constructor(private confirmationService: ConfirmationService,
              private notificationService: NotificationsService) { }

  update(updateFunction, onSuccess, entityTypeName: string) {
    this.confirmationService.confirm({
      message: 'Do you really want to update this ' + entityTypeName + '? The operation cannot be reverted.',
      accept: () => {
        const updateSubscription = updateFunction()
          .finally(() => {updateSubscription.unsubscribe()})
          .subscribe((result) => {
            if (result.messages.length > 0) {
              let notification = '';
              result.messages.forEach((message) => {
                notification += message.message + '<br/>';
              });
              this.notificationService.warn('Update successful', notification);
              onSuccess();
            } else {
              this.notificationService.success('Update not needed', 'The ' + entityTypeName + ' is up-to-date.');
            }
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/services/update.service.ts